import {Component, EventEmitter, Input, Output, SimpleChanges} from '@angular/core';
import {AuthError} from '../../dynamic-display/dynamic-display.component';

@Component({
  selector: 'app-list-2fa',
  templateUrl: './list-2fa.component.html',
  styleUrls: ['./list-2fa.component.less', '../../shared/common.less']
})
export class List2FAComponent {
  @Input() password: string;
  @Input() validatedPassword = true;
  @Input() validatedSMS = true;
  @Input() phoneNumber: string;
  @Input() phoneChangeable: boolean;
  @Input() welcomeText: string;
  @Input() retries: number;
  @Input() noMoreSMS = false;
  @Input() isValidationCodeError = false;
  @Input() validationErrorObj: AuthError;
  @Input() isWrongPhoneError = false;
  @Input() smsSent = false;
  @Input() changeablePhone = false;

  @Output() sendSmsFirstEvent = new EventEmitter();
  @Output() sendSMSEvent = new EventEmitter<boolean>();
  @Output() sendPasswordEvent = new EventEmitter<string>();
  @Output() sendPhoneEvent = new EventEmitter<string>();
  @Output() sendCodeEvent = new EventEmitter<string>();

  shouldCalculateError = false;
  shouldChangePhone = false;
  value: string;

  resendSMS() {
    this.sendSMSEvent.emit(true);
  }

  sendSms() {
    this.sendSmsFirstEvent.emit();
    this.smsSent = true;
  }

  sendPassKey() {
    this.shouldCalculateError = true;
    const password = (document.getElementById('pass-txt') as HTMLInputElement).value;
    this.sendPasswordEvent.emit(password.trim());
  }

  sendPhoneNumber() {
    const password = (document.getElementById('phone-txt') as HTMLInputElement).value;
    this.sendPhoneEvent.emit(password.trim());
    this.shouldChangePhone = false;
  }

  // Méthode simplifiée pour p-inputOtp (PrimeNG gère la navigation et validation)
  codeInput($event) {
    console.log('Code input event:', $event);
    // PrimeNG InputOtp gère automatiquement la navigation et les restrictions
    // Cette méthode sert juste pour le logging si besoin
  }

  resetPhoneError() { this.isWrongPhoneError = false; }

  getPhoneNumberPlaceholder() { return this.phoneNumber != null ? this.phoneNumber : '33123456789'; }

  // Méthode simplifiée : p-inputOtp utilise [(ngModel)]="value" pour récupérer le code
  validate() {
    console.log('validate');

    if (this.value && this.value.length === 6) {
      this.sendCodeEvent.emit(this.value);
      this.shouldCalculateError = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.isValidationCodeError) {
      if (this.isValidationCodeError) {
        if (this.validationErrorObj != null && this.validationErrorObj.code === 429) {
          if (this.validationErrorObj.time != null) {
           const timeDelta = 60000 + this.validationErrorObj.time.getTime() - Date.now();
           if (timeDelta > 0) {
             const submitButton = document.getElementById('pass-butt') as HTMLButtonElement;
             submitButton.hidden = true;
             setTimeout(() => {
               submitButton.hidden = false;
             }, timeDelta);
           }
          }
        }
      }
    }
  }
}
